export const RecallEffectivenessChart = {
  flow: 'y',
  gap: 'Z',
  padding: 'B',
  round: 'A',
  background: 'inkMid',
  border: '1px solid inkBorder',
  StatsRow: {
    flow: 'x',
    gap: 'A',
    flexWrap: 'wrap',
    TotalDue: {
      flow: 'y',
      gap: 'W',
      Label: { text: '{{ totalDue | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Val: { text: (el, s) => s.totalDue || '0', fontSize: 'A', fontWeight: '700', color: 'inkText' }
    },
    Scheduled: {
      flow: 'y',
      gap: 'W',
      Label: { text: '{{ scheduled2 | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Val: { text: (el, s) => s.scheduled || '0', fontSize: 'A', fontWeight: '700', color: 'teal' }
    },
    Completed: {
      flow: 'y',
      gap: 'W',
      Label: { text: '{{ completed2 | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Val: { text: (el, s) => s.completed || '0', fontSize: 'A', fontWeight: '700', color: 'green' }
    },
    OverdueCount: {
      flow: 'y',
      gap: 'W',
      Label: { text: '{{ overdue2 | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Val: { text: (el, s) => s.overdueCount || '0', fontSize: 'A', fontWeight: '700', color: 'red' }
    },
    ReactivationRate: {
      flow: 'y',
      gap: 'W',
      Label: { text: '{{ reactivation | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Val: { text: (el, s) => (s.reactivationRate || '0') + '%', fontSize: 'A', fontWeight: '700', color: 'teal' }
    }
  },
  ChartLabel: { text: '6-Month Trend', fontSize: 'Y', color: 'inkMuted', fontWeight: '600', marginTop: 'Y' },
  BarChart: {
    flow: 'x',
    align: 'flex-end center',
    gap: 'Y',
    height: 'F',
    padding: 'Y 0',
    Bar1: { flex: '1', background: 'teal', round: 'Y Y 0 0', height: (el, s) => (s.month1 || '40') + '%', transition: 'height 0.3s ease' },
    Bar2: { flex: '1', background: 'teal', round: 'Y Y 0 0', height: (el, s) => (s.month2 || '55') + '%', transition: 'height 0.3s ease' },
    Bar3: { flex: '1', background: 'teal', round: 'Y Y 0 0', height: (el, s) => (s.month3 || '65') + '%', transition: 'height 0.3s ease' },
    Bar4: { flex: '1', background: 'teal', round: 'Y Y 0 0', height: (el, s) => (s.month4 || '50') + '%', transition: 'height 0.3s ease' },
    Bar5: { flex: '1', background: 'teal', round: 'Y Y 0 0', height: (el, s) => (s.month5 || '75') + '%', transition: 'height 0.3s ease' },
    Bar6: { flex: '1', background: 'teal', round: 'Y Y 0 0', height: (el, s) => (s.month6 || '85') + '%', transition: 'height 0.3s ease' }
  }
}
